import { Fragment } from 'react';
import styles from './FundDataLoader.module.scss';

interface FundDataProps {
    isTablet: boolean;
    isDesktop: boolean;
}

export default function FundDataLoader(props: FundDataProps) {
    const { isTablet, isDesktop } = props;
    if (!isDesktop && !isTablet) {
        return <FundDataMobileLoader />;
    } else if (isDesktop) {
        return (
            <>
                <section className={styles.fundContainer}>
                    <section className={styles.thead}>
                        <article className={`${styles.rowItem} ${styles.fundsTokens}`}>Fund</article>
                        <article className={`${styles.rowItem} ${styles.price}`}>Price</article>
                        <article className={`${styles.rowItem} ${styles.change}`}>Change 24h</article>
                        <article className={`${styles.rowItem} ${styles.tvl}`}>TVL</article>
                        <article className={`${styles.rowItem} ${styles.fee}`}>Staked</article>
                    </section>
                    <section className={styles.tbody}>
                        <div className={styles.rowSkeleton}></div>
                    </section>
                </section>
                <section className={styles.moreDetails}>
                    <div className={styles.rowSkeleton}></div>
                </section>
            </>
        );
    }
}

const FundDataMobileLoader = () => {
    const skeletonData = Array(5)
        .fill(null)
        .map((_, index) => ({
            _DB_id: index,
        }));
    return (
        <section className={styles.fundContainer}>
            {skeletonData.map((fund) => (
                <Fragment key={fund._DB_id}>
                    <article className={styles.row}>
                        <div className={styles.col}>
                            <div className={styles.rowSkeletonMob}></div>
                        </div>
                        <div className={styles.col}>
                            <div className={styles.rowSkeletonMob}></div>
                        </div>
                    </article>
                </Fragment>
            ))}
        </section>
    );
};
